import moment from 'moment';
import { intervalToMinutes } from '../consts/monitoringInterval.const';

const DomainMonitorListColumn = (type) => [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 80
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    sorter: (a, b) => (a.domain || '').localeCompare(b.domain || ''),
    slot: 'domain',
    width: 150
  },
  {
    title: 'Contact Group',
    dataIndex: 'contactGroup',
    slot: 'contactGroup',
    width: 200
  },
  {
    title: 'Interval',
    dataIndex: 'interval',
    slot: 'interval',
    sorter: (a, b) => intervalToMinutes(a.interval) - intervalToMinutes(b.interval),
    width: 150
  },
  {
    title: 'Last Verified',
    dataIndex: 'lastVerified',
    slot: 'lastVerified',
    sorter: (a, b) => moment(a.lastVerified).diff(moment(b.lastVerified)),
    width: 200
  },
  {
    title: `${type} Status`,
    dataIndex: 'status',
    slot: 'status',
    sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
    width: 150
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];

export { DomainMonitorListColumn };
